import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { faInfoCircle } from '@fortawesome/pro-duotone-svg-icons/faInfoCircle';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TooltipDirective, TooltipPosition } from '../../ui/tooltip/tooltip.directive';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'andor-mat-slider-wrapper',
  standalone: true,
  imports: [CommonModule, FaIconComponent, TooltipDirective],
  templateUrl: './mat-slider-wrapper.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './mat-slider-wrapper.scss',
})
export class MatSliderWrapper {
  protected readonly faInfoCircle = faInfoCircle;

  @Input() label = '';
  @Input() value?: number;
  @Input() tooltipText?: string;
  @Input() tooltipDirection: TooltipPosition = 'above';
  @Input() colorMode = '';
}
